import { render, staticRenderFns } from "./PorPagar.vue?vue&type=template&id=52f4f806"
import script from "./PorPagar.vue?vue&type=script&lang=js"
export * from "./PorPagar.vue?vue&type=script&lang=js"
import style0 from "./PorPagar.vue?vue&type=style&index=0&id=52f4f806&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports